import { useTranslation } from 'react-i18next';

import { KpiLatestEntryCard } from '@/features/dashboard/components/dashboard/kpi-latest-entry-card';
import { useKpisWithLatestEntries } from '@/features/dashboard/hooks/use-kpis-with-latest-entries';
import { BlurredContainer } from '@/features/insights/components/blurred-container';
import InfoPurple from '@/shared/assets/info-purple.svg?react';
import { EmptyTablePlaceholderContent } from '@/shared/components/table/empty-table-placeholder';
import { Button } from '@/shared/components/ui/button';
import { Card } from '@/shared/components/ui/card';
import { Skeleton } from '@/shared/components/ui/skeleton';

export const KpiLatestEntriesSection = () => {
  const { data: kpis, isLoading } = useKpisWithLatestEntries();
  const noData = !kpis || kpis?.length === 0;
  const { t } = useTranslation('overview', {
    keyPrefix: 'OverviewPage.emptyBottomCards',
  });

  if (isLoading) {
    return (
      <div className="flex gap-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            className="h-[345px] w-[400px] rounded-[24px]"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="relative">
      <div className="flex justify-evenly gap-4 overflow-x-auto pb-2">
        {[0, 1, 2, 3].map((index) => {
          const kpi = kpis?.[index];

          return (
            <BlurredContainer className="w-full" isBlurred={noData} key={index}>
              {kpi ? (
                <KpiLatestEntryCard key={index} kpi={kpi} />
              ) : (
                <Card
                  variant={'informationAlt'}
                  className="h-[345px] bg-light-container"
                />
              )}
            </BlurredContainer>
          );
        })}
      </div>
      {noData && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
          <Button
            variant={'outline'}
            btnType={'icon'}
            shape={'circle'}
            className="size-10 p-1"
          >
            <InfoPurple />
          </Button>
          <EmptyTablePlaceholderContent
            className="w-[200px] p-0 md:w-[500px]"
            title={t('title')}
            description={t('description')}
            centered
          />
        </div>
      )}
    </div>
  );
};
